module.exports = __webpack_public_path__ + "static/LCScriptWeb-Regular-8715baf114c13fecf4b914a16001f175.woff2";